import { Component } from '@angular/core';

@Component({
  selector: 'uni-box-footer',
  templateUrl: './uni-box-footer.component.html',
  styleUrls: ['./uni-box-footer.component.scss'],
})
export class UniBoxFooterComponent {
}
